import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { Tabs } from '../../../../../../common/tabs'
import { getAppendStyleItemWithCustom } from '../../../../../../common/tabs/helper'
import { getYearTabs } from '../../../helper'
import classes from '../../../index.module.scss'
import { changeYear, selectYear } from '../../../store/slice'
import {
  selectDataViewByEachYear,
  selectIndicatorById,
  selectYears,
} from '../store/slice'
import { valToPercent } from './../../../../../../helpers/value'
import { SECTOR_CODES } from './constant'

const COLORS = ['#006AA6', '#F49966', '#00A8B5']

const TopSector = ({ id, year: yearSetting, isDynamicReport }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const year = useSelector(selectYear(id, yearSetting))
  const dataEachYear = useSelector(selectDataViewByEachYear(year))
  const indicatorById = useSelector(selectIndicatorById)
  const years = useSelector(selectYears)

  const tabs = getYearTabs(years)

  const setYear = (year) => dispatch(changeYear({ id, year }))

  useEffect(() => {
    if (
      (tabs.length && !year) ||
      !tabs.map((item) => item.key).includes(String(year))
    ) {
      setYear(tabs[tabs.length - 1]?.key)
    }
  }, [tabs.length, year])

  const topSectors = useMemo(() => {
    const sectors = dataEachYear.filter((item) =>
      SECTOR_CODES.includes(item.id),
    )
    const totalLoans = sectors.reduce((prev, curr) => prev + curr.value, 0)
    const result = sectors
      .map((item) => ({
        ...item,
        percent: item.value / totalLoans,
      }))
      .sort((a, b) => b.percent - a.percent)

    return result.slice(0, 3)
  }, [dataEachYear])

  return (
    <>
      <div className="dFlex alignItemsCenter justifyContentBetween">
        <div className={!isDynamicReport ? 'fw600 pr1' : 'w100 fw600 pr1'}>
          <Translate value="financialAnalysis.TOP_3_SECTOR_IN_LOAN_PORTFOLIO" />
        </div>
        {!isDynamicReport ? (
          <Tabs
            activeKey={year}
            items={tabs}
            tabListClassName={classes.tabs}
            styleContent={{ marginTop: 0 }}
            getAppendStyleItem={getAppendStyleItemWithCustom()}
            isScrollContent={false}
            onChange={setYear}
          />
        ) : (
          <div className="fw600 py1 w100 textEnd">
            <Translate value="common.FISCAL_YEAR" />: {year}
          </div>
        )}
      </div>
      <div className="mt1 pb3">
        {topSectors.map((item, index) => {
          return (
            <Element
              key={item.id}
              style={{ borderBottom: '1px solid #D5D5D5' }}
              className="px1 py1 dFlex alignItemsCenter"
            >
              <div
                style={{ color: COLORS[index] }}
                className={classes.sectorOrder}
              >
                #{index + 1}
              </div>
              <div className="w100">
                {indicatorById[item.id]?.ratioName || ''}
              </div>
              <div
                style={{ backgroundColor: COLORS[index], color: '#FFFFFF' }}
                className={classes.sectorValue}
              >
                {valToPercent(item.percent, locale)}
              </div>
            </Element>
          )
        })}
      </div>
    </>
  )
}

export default TopSector
